import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

interface ErrorMessageProps {
  children: string
}

const StyledErrorMessage = styled.div`
  ${({
    theme: {
      colors: { textBrand },
      typography: {
        bodycopy: {
          xxsmall: { bundledCSS: xxsmallBodycopyCSS },
        },
      },
    },
  }) => css`
    ${xxsmallBodycopyCSS};
    color: ${textBrand};
  `}
`

const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({ children }) => (
  <StyledErrorMessage>{children}</StyledErrorMessage>
)

export default ErrorMessage
